exports.install=function(Vue,options){
    Vue.directive('title',{
        inserted:function(el){
            document.title = el.dataset.title;
            Vue.prototype.rootglobal.commit('settitle', el.dataset.title)
        }
    })
}


// WEBPACK FOOTER //
// ./src/js/directive.js